import { CommonModule } from '@angular/common'
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { ValueChangeComponent } from '@vg-constellation/angular-16/value-change'
import {
  DataTableBodyCellComponent,
  DataTableBodyRowComponent,
  DataTableCaptionComponent,
  DataTableComponent,
  DataTableHeaderCellComponent,
  DataTableHeaderRowComponent,
} from '@vg-constellation/patterns-angular/data-table'

import { VgConstellationModule } from '../../shared/modules/vg-constellation/vg-constellation.module'
import { CustomDatePipe } from '../../shared/pipe/custom-date.pipe'
import { ExpenseRatioValuePipe } from '../../shared/pipe/expense-ratio-value.pipe'
import { PercentagePipe } from '../../shared/pipe/percentage.pipe'
import { SortPipe } from '../../shared/pipe/sort.pipe'
import { BannerErrorComponent } from '../errors/banner-error/banner-error.component'
import { FiltersModule } from '../filters/filters.module'
import { FundLiteratureTableComponent } from '../fund-literature-table/fund-literature-table.component'
import { NoDataPageComponent } from '../no-data-page/no-data-page.component'
import { PageFootnoteComponent } from '../page-footnote/page-footnote.component'
import { PerformanceTableComponent } from '../performance-table/performance-table.component'
import { ViewTypeComponent } from '../view-type/view-type.component'
import { FundListComponent } from './fund-list.component'
@NgModule({
  declarations: [
    FundListComponent,
    PerformanceTableComponent,
    FundLiteratureTableComponent,
    NoDataPageComponent,
    PercentagePipe,
    CustomDatePipe,
    ExpenseRatioValuePipe,
    ViewTypeComponent,
    PageFootnoteComponent,
    BannerErrorComponent,
    SortPipe,
    BannerErrorComponent,
  ],
  imports: [
    VgConstellationModule,
    CommonModule,
    BrowserAnimationsModule,
    FiltersModule,
    DataTableComponent,
    DataTableHeaderRowComponent,
    DataTableBodyRowComponent,
    DataTableHeaderCellComponent,
    DataTableBodyCellComponent,
    DataTableCaptionComponent,
    ValueChangeComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class FundListModule {}
